export const historyBankingTransactionTableColumns = [
  { header: "Type", accessor: "type" as const },
  { header: "Amount", accessor: "amount" as const },
  { header: "Currency", accessor: "currency" as const },
  { header: "Status", accessor: "status" as const },
  { header: "Date & time", accessor: "createdAt" as const },
  { header: "Description", accessor: "description" as const },
];
